import classnames from 'classnames';
import { path } from 'ramda';
import React, { FC } from 'react';
import { ExternalSourcesConfigs } from '../../../containers/FilesImporter/constants/Sources';
import styles from './SourceIcon.scss';
import { IOuter } from './SourceIcon.types';

export const SourceIcon: FC<IOuter> = ({ source, className }) => {
  const IconComponent = path<FC>([source, 'IconComponent'], ExternalSourcesConfigs);

  if (!IconComponent) {
    return null;
  }

  return (
    <div className={classnames(styles.icon, className)} data-hook="source-icon">
      <IconComponent />
    </div>
  );
};
